window.App.ToggleDropDown = function (button) {
    let toggleNode = button.closest('li').querySelector('ul');
    if(toggleNode.classList.contains('opened')) {
        button.classList.remove('opened');
        toggleNode.classList.remove('opened');
    } else {
        toggleNode.classList.add('opened');
        button.classList.add('opened');
    }
}